var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard"}},[(_vm.user && _vm.user.admin)?_c('Admin'):(_vm.user && !_vm.user.admin)?_c('User'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }